export default __webpack_public_path__ + "static/media/iqrf-applicability.68f02723.jpg";